import { Trans, useTranslation } from "react-i18next";
import { openChatWidget } from "@help-center/flip-chat-widget";

import { Button, Modal } from "src/components-v2";
import { ModalProps } from "src/components-v2/Modal";

import IconWrongAccount from "src/assets/images/common/ilus-wrong-account.png";

export type AccountNumberModalProps = ModalProps & {
  /**
   * Set function to toggle show
   */
  toggle?: (_arg: boolean) => void;

  /**
   * check if its reach inquiry limit
   */
  isLimitInquiry?: boolean;
};

const defaultProps = {
  show: false,
  toggle: () => {},
  isLimitInquiry: false
};

function AccountNumberModal(props: AccountNumberModalProps) {
  const { show, toggle, isLimitInquiry, ...rest } = props;
  const { t } = useTranslation("translation");

  return (
    <Modal show={show} onClose={() => toggle(false)} closeOnOverlay withoutHeader {...rest}>
      <div className="u-text-center">
        <img src={IconWrongAccount} alt="logo-wrong-account" className="u-w-2/4 u-mb-3" />
      </div>
      <p className="u-font-bold u-text-large u-text-center">
        {t(`check-account-modal.${isLimitInquiry ? "reach-limit" : "invalid"}.title`)}
      </p>

      {isLimitInquiry ? (
        <p>
          <Trans t={t} i18nKey={"check-account-modal.reach-limit.content"}>
            <span className="u-font-bold u-cursor-pointer u-underline" onClick={openChatWidget} />
          </Trans>
        </p>
      ) : (
        <>
          <p className="u-m-0">{t("check-account-modal.invalid.subtitle")}</p>

          <ul className="u-pl-4">
            <li>{t("check-account-modal.invalid.list.item-1")}</li>
            <li>{t("check-account-modal.invalid.list.item-2")}</li>
            <li>{t("check-account-modal.invalid.list.item-3")}</li>
            <li>{t("check-account-modal.invalid.list.item-4")}</li>
          </ul>
        </>
      )}

      <Button variant="secondary" onClick={() => toggle(false)} block>
        {t("check-account-modal.button")}
      </Button>
    </Modal>
  );
}

AccountNumberModal.defaultProps = defaultProps;

export default AccountNumberModal;
